import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classnames from "classnames";
import BenefitIcon from "static/svg/templates-store/benefit_icon.svg";
import { StyledBenefit } from "./benefit-component.scss";
const Benefit = ({ title, description, alignToCenter })=>{
    return /*#__PURE__*/ _jsxs(StyledBenefit, {
        className: classnames("benefit-component", {
            "align-center": alignToCenter
        }),
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "benefit-icon-wrapper",
                children: /*#__PURE__*/ _jsx(BenefitIcon, {
                    className: "benefit-icon"
                })
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "benefit-content",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "benefit-title",
                        children: title
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "benefit-description",
                        children: description
                    })
                ]
            })
        ]
    });
};
export default Benefit;
